/**
 * 中国大陆车牌：去掉「·」、空格、横杠后，长度必须为 7（普通）或 8（新能源），多一位少一位均不通过。
 * 结构：省份汉字 + 发牌机关字母（不含 I/O）+ 序号（字母数字，不含 I/O）
 */
const REG_PLATE_7 =
  /^[\u4e00-\u9fa5][A-HJ-NP-Z][A-HJ-NP-Z0-9]{5}$/;
const REG_PLATE_8 =
  /^[\u4e00-\u9fa5][A-HJ-NP-Z][A-HJ-NP-Z0-9]{6}$/;

/** 与各进件页 Toast 统一 */
export const PLATE_NUMBER_FORMAT_ERROR_MSG = "请输入正确的车牌号";

export function validateChinesePlateNumber(plate) {
  if (plate == null || typeof plate !== "string") return false;
  let p = plate.trim();
  if (!p) return false;
  p = p.replace(/[·\s\-]/g, "");
  if (p.length !== 7 && p.length !== 8) return false;
  const upper = p.replace(/[a-z]/g, (c) => c.toUpperCase());
  return REG_PLATE_7.test(upper) || REG_PLATE_8.test(upper);
}
